import { Message } from '@arco-design/web-vue';
import { migrationToolsService } from '@/api';
import { useMigrationToolsStore } from '@/store';

export default function useActions(params) {
  const migrationToolsStore = useMigrationToolsStore();
  const tenantId = migrationToolsStore.tenantId;
  const currentStep = params.currentStep;
  const currentEntity = params.dataEntity;

  // 操作按钮是否能点击
  const getMigrationStatus = () => {
    migrationToolsStore.getMigrationStatus({
      tenantId
    });
  };
  // 列表数据
  const getDataList = () => {
    migrationToolsStore.getDataTaskList({
      tenantId,
      type: String(currentStep.value),
      entityId: currentEntity?.value
    });
  };
  //获取模块
  const getModules = () => {
    migrationToolsStore.getModules();
  };
  const handleRefresh = () => {
    getMigrationStatus();
    getDataList();
  };
  // 重新导出
  const handleExportItem = async (record) => {
    try {
      const res = await migrationToolsService.postReExport({
        tenantId,
        dataType: record.dataType,
        entityId: currentEntity?.value
      });
      if (res.result?.result) {
        Message.success('操作成功');
        setTimeout(() => {
          handleRefresh();
        }, 1000);
      } else {
        Message.error(res.result?.msg || '操作失败');
      }
    } catch (err) {
      Message.error(err?.message || '操作失败');
    }
  };
  // 重新导入
  const handleImportItem = async (record) => {
    try {
      const res = await migrationToolsService.postReImport({
        tenantId,
        dataType: record.dataType
      });
      if (res.result?.result) {
        Message.success('操作成功');
        setTimeout(() => {
          handleRefresh();
        }, 1000);
      } else {
        Message.error(res.result?.msg || '操作失败');
      }
    } catch (err) {
      Message.error(err?.message || '操作失败');
    }
  };
  // 一键开启导出
  const handleExportAll = async () => {
    try {
      const res = await migrationToolsService.postOneClickExport({
        tenantId
      });
      if (res.result?.result) {
        Message.success('操作成功');
        setTimeout(() => {
          handleRefresh();
        }, 1000);
      } else {
        Message.error(res.result?.msg || '操作失败');
      }
    } catch (err) {
      Message.error(err?.message || '操作失败');
    }
  };

  // 一键开启导入
  const handleImportAll = async (part) => {
    if (part === 2) {
      updateImportStatus();
      return;
    }
    try {
      const res = await migrationToolsService.postOneClickImport({
        tenantId,
        part
      });
      if (res.result?.result) {
        Message.success('操作成功');
        setTimeout(() => {
          handleRefresh();
        }, 1000);
      } else {
        Message.error(res.result?.msg || '操作失败');
      }
    } catch (err) {
      Message.error(err?.message || '操作失败');
    }
  };
  // 第二部分-确认台账导入
  const updateImportStatus = async () => {
    try {
      const res = await migrationToolsService.postUpdateTenantImportStatus({
        tenantId,
        importPart2Enable: true
      });
      if (res.result?.result) {
        Message.success('操作成功');
        setTimeout(() => {
          handleRefresh();
        }, 1000);
      } else {
        Message.error(res.result?.msg || '操作失败');
      }
    } catch (err) {
      Message.error(err?.message || '操作失败');
    }
  };
  return {
    handleExportAll,
    handleImportAll,
    handleExportItem,
    handleImportItem,
    handleRefresh,
    getDataList,
    getModules
  };
}
